export const replaceHttpWithHttps = url => url.replace('http://', 'https://');
